import BaseApi from '@core/api/model';

import { attachHeaders } from '@utils/api';

export class BrandingApi extends BaseApi {
    static resource = 'branding';

    get endpoints() {
        return {
            get: this.get.bind(this),
            put: super.endpoints.put.bind(this),
            setColours: this.setColours.bind(this),
            setImage: this.setImage.bind(this)
        };
    }

    _createBrandingObject(id, name, brandingData) {
        return {
            id,
            name,
            _text: brandingData.text,
            _colours: brandingData.colours,
            _images: brandingData.images,
            _dark: brandingData.dark,
            _custom_app_url: brandingData.custom_app_url
        };
    }

    _filterIndexResponseData(data) {
        if (!data) {
            return [];
        }

        const branding = [];
        const allOrgs = [...(data.organisations || []), ...data.linked_users?.flatMap(linked => linked.organisations)];

        for (const org of allOrgs) {
            if (!org) continue;

            if (org.type === 'INVESTOR') {
                for (const acc of org.accounts || []) {
                    if (acc.branding) {
                        branding.push(this._createBrandingObject(acc.adviser_id, acc.adviser_name, acc.branding));
                    }
                }
            } else {
                if (org.branding) {
                    branding.push(this._createBrandingObject(org.id, org.name, org.branding));
                }
            }
        }

        return branding;
    }

    async get(id = null) {
        if (id) {
            const data = await BaseApi.api.get(`${this.base_url}/${id}`);
            return this._filterGetResponseData(data);
        } else {
            const data = await BaseApi.api.get(this.base_url);
            return this._filterIndexResponseData(data);
        }
    }

    async setColours(organisation_id, colours = []) {
        return BaseApi.api.put(`${this.base_url}/${organisation_id}/colours`, colours);
    }

    async setImage(organisation_id, image = {}) {
        return BaseApi.api.put(
            `${this.base_url}/${organisation_id}/image`,
            { key: image.key, image: image.file },
            { headers: attachHeaders({ 'Content-Type': 'multipart/form-data' }) }
        );
    }
}

export default BrandingApi;
